import { createFileRoute, Link } from "@tanstack/react-router"
import { Calendar, Sailboat, Ship, Utensils } from "lucide-react"

import { Card, CardContent } from "@/components/ui/card"

export const Route = createFileRoute("/_layout/calendar/")({
  component: CalendarLandingPage,
  staticData: {
    pageTitle: "Calendars",
    pageIcon: Calendar,
    pageIconClassName: "text-primary",
  },
  head: () => ({
    meta: [
      {
        title: "Calendars - Broken Islands Booking",
      },
    ],
  }),
})

const calendarLinks = [
  {
    to: "/calendar/taxi" as const,
    icon: Ship,
    label: "Water Taxi",
    description: "View and manage water taxi schedules",
  },
  {
    to: "/calendar/kayak" as const,
    icon: Sailboat,
    label: "Kayak Rentals",
    description: "Track kayak availability and bookings",
  },
  {
    to: "/calendar/kitchen" as const,
    icon: Utensils,
    label: "Kitchen",
    description: "View meal prep and kitchen schedules",
  },
]

function CalendarLandingPage() {
  return (
    <div className="container py-6">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {calendarLinks.map(({ to, icon: Icon, label, description }) => (
          <Link key={to} to={to}>
            <Card className="hover:border-primary/50 transition-colors cursor-pointer h-full">
              <CardContent className="flex flex-col items-center justify-center py-8 text-center">
                <Icon className="h-10 w-10 text-primary mb-3" />
                <h2 className="text-lg font-medium mb-1">{label}</h2>
                <p className="text-sm text-muted-foreground">{description}</p>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  )
}
